import axios from 'axios'
import { Toast } from 'vant'
import Cache from './cache'
// 创建 axios 实例
const service = axios.create({
  // 超时时间
  timeout: 10000
})
let loadingToast = null
let loadingCounter = 0
const axiosCache = new Cache(service)
service.interceptors.request.use(
  config => {
    // 这里是处理 请求前 的操作
    const cache = config.headers.cache
    if (cache) {
      axiosCache.defaultConfig.cache = cache
      delete config.headers.cache
    }
    if (axiosCache.defaultConfig.cache) {
      const result = hitCache(config)
      if (result) {
        return result
      }
    }
    // 在请求头参数配置 loading: true 会出现此加载框
    if (config.headers.loading) {
      delete config.headers.loading
      if (loadingCounter === 0) {
        loadingToast = Toast.loading()
      }
      loadingCounter++
    }
    return config
  },
  error => {
    //  这里处理一些请求出错的情况
    console.error(error)
    Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    // #region loading
    if (loadingToast) {
      loadingCounter--
      if (loadingCounter === 0) {
        loadingToast.clear()
        loadingToast = null
      }
    }
    // #endregion loading
    const data = response.data
    // 这里处理一些 response 正常返回时的逻辑
    // if (data.hasOwnProperty('status') && data.status !== 0) {
    //   if (data.info && data.info.msg) {
    //     Toast.fail(data.info.msg)
    //     return Promise.reject(data)
    //   }
    // }
    if (axiosCache.defaultConfig.cache) {
      const cacheKey = axiosCache.normalizeKey(response.config)
      const obj = {
        expire: axiosCache.getCurrentTime(),
        params: response.config.params,
        data: response.config.data,
        result: data
      }
      axiosCache.keys.push(cacheKey)
      axiosCache.setCache(axiosCache.defaultConfig.cacheMode, cacheKey, obj)
    }
    return data
  },
  error => {
    console.log('error', error)
    /**
     * 返回缓存数据
     */
    if (axios.isCancel(error)) {
      return Promise.resolve(error.message.result)
    }
    if (!error.response) {
      if (error.message.includes('timeout')) {
        Toast.fail('网络连接超时，请重试')
      } else {
        Toast.fail('网络连接失败')
      }
    }
    // 这里处理一些response 出错时的逻辑
    return Promise.reject(error)
  }
)
/**
 * @description 是否命中缓存
 * @author lentoo
 * @date 2019-04-03
 * @param {*} config
 */
function hitCache (config) {
  const key = axiosCache.normalizeKey(config)
  const result = axiosCache.getCache(axiosCache.defaultConfig.cacheMode, key)
  /**
   * 判断缓存是否存在
   */
  if (result) {
    /**
     * 判断缓存是否过期
     */
    const source = axios.CancelToken.source()
    config.cancelToken = source.token
    if (axiosCache.defaultConfig.expire > axiosCache.getCurrentTime() - result.expire) {
      source.cancel(result)
      return config
    } else {
      axiosCache.removeCache(key)
    }
  }
  return null
}
export default service
